export default __webpack_public_path__ + "assets/c841d07bb1f7aad8403c5f60c3c3bdba.webp";